<template>
  <custom-dropdown-group :group-header="selectParams.title">
    <template v-slot:group-content>
      <v-flex xs6>
        <search-select-element
          :element.sync="minValue"
          :options="dropdownOptions"
          placeholder="No min"
          :select-params="selectParams"
        />
      </v-flex>
      <v-flex xs6>
        <search-select-element
          :element.sync="maxValue"
          :options="maxValueOptions"
          placeholder="No max"
          :select-params="selectParams"
        />
      </v-flex>
    </template>
  </custom-dropdown-group>
</template>

<script>
import CustomDropdownGroup from '../../common/search/CustomDropdownGroup.vue'
import SearchSelectElement from './SearchSelectElement.vue'
import { isEmpty } from '../../../utils/generalUtils'

export default {
  components: {
    CustomDropdownGroup,
    SearchSelectElement
  },

  props: {
    initialValue: {
      type: String,
      default: ''
    },
    dropdownOptions: {
      type: Array,
      required: true
    },
    selectParams: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      minValue: '',
      maxValue: ''
    }
  },

  computed: {
    maxValueOptions() {
      let updatedOptions = []
      if (isEmpty(this.minValue)) {
        updatedOptions = this.dropdownOptions.slice(1)
      } else {
        const minValueIndex = this.dropdownOptions.findIndex(
          option => option.value === this.minValue
        )
        updatedOptions = this.dropdownOptions.slice(minValueIndex + 1)
      }
      updatedOptions.unshift({
        text: 'No max',
        value: ''
      })
      return updatedOptions
    }
  },

  watch: {
    minValue(value) {
      if (parseInt(value) > parseInt(this.maxValue)) {
        this.maxValue = ''
      }
      this.updateValue()
    },

    maxValue(value) {
      this.updateValue()
    },

    initialValue(value) {
      this.setInitialValue(value)
    }
  },

  mounted() {
    this.setInitialValue(this.initialValue)
  },

  methods: {
    setInitialValue(value) {
      if (value) {
        this.minValue = value.substr(
          0,
          value.indexOf('-')
        )
        this.maxValue = value.substr(
          value.indexOf('-') + 1
        )
      } else {
        this.minValue = ''
        this.maxValue = ''
      }
    },
    updateValue() {
      const valueRange = `${this.minValue || this.selectParams.min}-${this
        .maxValue || this.selectParams.max}`
      this.$emit('update-value', valueRange)
    }
  }
}
</script>

<style lang="sass" scoped>
.area-range-input
  border-radius: 0.5rem
  padding: 0.7rem
  border: 1px solid $hwayzBlack
  font-size: 1.4rem
  max-width: 12rem
  margin: 6px 8px
</style>
